document.addEventListener('DOMContentLoaded', () => {

  let currentDropdown = null;

  function closeDropdown() {
    if (currentDropdown) {
      const selectUl = currentDropdown.querySelector('.select ul');
      currentDropdown.querySelector('.select').classList.remove('open');
      selectUl.setAttribute('aria-expanded', 'false');
      selectUl.setAttribute('aria-pressed', 'false');
      currentDropdown = null; // Reset current open dropdown
    }
  }

  function handleDropdownChange(dropdownId, targetDivId, targetHeaderId, dropdownTriggerId) {
    const dropdown = document.getElementById(dropdownId);
    const targetHeader = document.getElementById(targetHeaderId);
    // Array of all possible dropdown IDs
    const dropdowns = ['productHandlesDropdown1', 'productHandlesDropdown2', 'productHandlesDropdown3'];
  
    // Determine other dropdowns by filtering out the current one
    const otherDropdownIds = dropdowns.filter(id => id !== dropdownId && document.getElementById(id));
  
    // Function to check if dropdown is open
    function isOpen() {
      return dropdown.querySelector('.select').classList.contains('open');
    }
  
    // Function to open the dropdown
    function openDropdown() {
      closeDropdown(); // Assume a closeDropdown function exists to close any open dropdown
      const selectUl = dropdown.querySelector('.select ul');
      const headerTitleWidth = targetHeader.querySelector('#headerTitle').getBoundingClientRect().width;
      var dropdownWidth = headerTitleWidth + 39;
  
      selectUl.style.width = `${dropdownWidth}px`;
      dropdown.querySelector('.select').classList.toggle('open');
      selectUl.setAttribute('aria-expanded', 'true');
      selectUl.setAttribute('aria-pressed', 'true');
      currentDropdown = dropdown; // This line is crucial
    }
  
    // Open or close the dropdown
    if (isOpen()) {
      closeDropdown();
      return;
    } else {
      openDropdown();
    }
  
    // Loop through options to handle selection
    for (const option of dropdown.querySelectorAll(".custom-option")) {
      option.addEventListener('click', function() {
        if (!this.classList.contains('selected')) {
          const previouslySelectedValue = dropdown.querySelector('.custom-option.selected')?.getAttribute('value');
          this.parentNode.querySelector('.custom-option.selected')?.classList.remove('selected');
          this.classList.add('selected');
          const selectedHandle = this.getAttribute('value');
  
          // Gather currently selected options across all dropdowns
          const currentlySelectedOptions = dropdowns.map(dropdownId => {
            const dropdownElement = document.getElementById(dropdownId);
            return dropdownElement ? dropdownElement.querySelector('.custom-option.selected')?.getAttribute('value') : null;
          }).filter(value => value !== null && value !== selectedHandle);
  
          // Enable previously selected option if it's not selected in another dropdown
          if (previouslySelectedValue && !currentlySelectedOptions.includes(previouslySelectedValue)) {
            dropdowns.forEach(dropdownId => {
              const optionToEnable = document.querySelector(`#${dropdownId} .custom-option[value="${previouslySelectedValue}"]`);
              if (optionToEnable) {
                optionToEnable.classList.remove('disabled-default');
              }
            });
          }
  
          // Disable the newly selected option in other dropdowns
          otherDropdownIds.forEach(otherDropdownId => {
            const optionToDisable = document.querySelector(`#${otherDropdownId} .custom-option[value="${selectedHandle}"]`);
            if (optionToDisable) {
              optionToDisable.classList.add('disabled-default');
            }
          });
  
          // Fetch new product markup based on the selected option
          fetch(`/products/${selectedHandle}?section_id=sr-api-compare-col`)
            .then(response => {
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then(productMarkup => {
              // Update the UI with the fetched product markup
              document.getElementById(targetDivId).innerHTML = productMarkup;
              let tempDiv = document.createElement('div');
              tempDiv.innerHTML = productMarkup;
  
              // Update various parts of the UI with the new content
              let headerComponents = ['#headerImage', '#headerPricing', '#headerTitle', '#mobileCustomBadge', '#desktopCustomBadge'];
              headerComponents.forEach(component => {
                let markup = tempDiv.querySelector(component).innerHTML;
                document.querySelector(`#${targetHeaderId} ${component}`).innerHTML = markup;
              });
            })
            .catch(error => {
              console.error('Error fetching product markup:', error);
            });
  
          closeDropdown(); // Close the dropdown after making a selection
        }
      });
  
      // Allow selection with the Enter key
      option.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          this.click();
        }
      });
    }
  }

  // Listeners for the dropdowns
  for (let i = 1; i <= 3; i++) {
    let dropdownTrigger = document.getElementById(`dropdownTrigger${i}`);

    dropdownTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation(); // Prevent the event from bubbling up
      handleDropdownChange(`productHandlesDropdown${i}`, `product-slot-${i}`, `headingContainerSlot${i}`, `dropdownTrigger${i}`);
    });

    // Add listener for the h2 element and the span element preceding the button
    let spanElement = dropdownTrigger.parentElement.previousElementSibling;
    let h2Element = spanElement ? spanElement.previousElementSibling : null;

    if (h2Element && h2Element.tagName === 'H2') {
      h2Element.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation(); // Prevent the event from bubbling up
        handleDropdownChange(`productHandlesDropdown${i}`, `product-slot-${i}`, `headingContainerSlot${i}`, `dropdownTrigger${i}`);
      });
    }

    if (spanElement && spanElement.tagName === 'SPAN') {
      spanElement.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation(); // Prevent the event from bubbling up
        handleDropdownChange(`productHandlesDropdown${i}`, `product-slot-${i}`, `headingContainerSlot${i}`, `dropdownTrigger${i}`);
      });
    }
  }

  // Function to handle tooltip trigger
  document.querySelectorAll('button#tooltipTrigger').forEach(function(tooltipTrigger) {
    tooltipTrigger.addEventListener('click', function(event) {
      event.stopPropagation();
      const tooltipContent = this.nextElementSibling;
      tooltipContent.classList.toggle('active');
    });
  });

  // Clicking on anything other than the tooltipTrigger or the actual tooltipContent should remove the active class
  document.addEventListener('click', function(event) {
    document.querySelectorAll('.tooltip-content.active').forEach(function(tooltipContent) {
      tooltipContent.classList.remove('active');
    });

    if (!currentDropdown) return;
    if (!currentDropdown.contains(event.target)) {
      closeDropdown();
    }
  });

  // Pressing escape should remove the active class
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.tooltip-content.active').forEach(function(tooltipContent) {
        tooltipContent.classList.remove('active');
      });
      if (currentDropdown) {
        closeDropdown();
      }
    }
  });

  
// Attach the listeners to the comparison table columns as these persist in the DOM when the SR API updates the individual components of the column. 
const comparisonTableColumns = document.querySelectorAll('.comparison-table__column');

// Attach and delegagte the event listeners to each column
comparisonTableColumns.forEach(column => {
  column.addEventListener('click', function(event) {
    if (event.target.matches('.feature-row__variant-swatches input[type="radio"]')) {
      const radio = event.target;

      // Update the nearest span.variant-value text with the value of the clicked radio input
      const variantValueSpan = radio.closest('.feature-row__variant-swatches').querySelector('.variant-value');
      if (variantValueSpan) {
        variantValueSpan.textContent = radio.value;
      }

      // Find the form with the matching ID from the radio input's form attribute
      const formId = radio.getAttribute('form');
      const form = document.getElementById(formId);
      if (form) {
        // Find the input with name="id" within the form and replace its value with the data-variant-id of the clicked radio input
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = radio.getAttribute('data-variant-id');
        }
      }
    }
  });
});
});
